import { ModuleID } from '../types'
import { ISurveyLogModule, ISurveyLogModuleConfigProps } from './types'

import DevLog from '../devlog/Module'
import { doInnerPost } from '../client/doPost'

let sendSurveyLogEndpointURL: string = null
let sendSurveyLogParams: Record<string, unknown> = null

let moduleLoaded = false
const SurveyLogModule: ISurveyLogModule = {
  get id() {
    return ModuleID.SURVEY_LOG
  },
  config({ url, params }: ISurveyLogModuleConfigProps = {}) {
    if (null != url) sendSurveyLogEndpointURL = url
    if (null != params) sendSurveyLogParams = params
    return SurveyLogModule
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(SurveyLogModule)
  },
  get loaded() {
    return moduleLoaded
  },
  async log(details) {
    if (sendSurveyLogEndpointURL) {
      try {
        await doInnerPost(sendSurveyLogEndpointURL, { ...(sendSurveyLogParams || {}), ...details })
      } catch (error) {
        DevLog.moduleError(SurveyLogModule, error, 'log')
      }
    } else {
      DevLog.moduleError(SurveyLogModule, new Error('endpoint not configured'))
    }
  }
}

export default SurveyLogModule
